import { render, staticRenderFns } from "./Defective.vue?vue&type=template&id=4e86be71&scoped=true"
import script from "./Defective.vue?vue&type=script&lang=js"
export * from "./Defective.vue?vue&type=script&lang=js"
import style0 from "./Defective.vue?vue&type=style&index=0&id=4e86be71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e86be71",
  null
  
)

export default component.exports